import loadable from '@loadable/component';

const PageEditor = loadable(
  () => import(/* webpackChunkName: "page-editor" */ './PageEditor')
);

PageEditor.displayName = 'PageEditor';

export default PageEditor;
